<template>
  <div class="store-detail-header">
    <div class="store-name">{{ data.storeName }}</div>
    <div class="store-info c:row-center">
      <SalerAvatar :name="data.managerName" is-manager />
      <div class="store-desc c:col-center-start">
        <p class="store-manager">店长：{{ data.managerName }}</p>
        <p class="store-salers">销售数：{{ data.caNumber }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import SalerAvatar from "../saler-list/SalerAvatar.vue";

export default {
  components: { SalerAvatar },
  props: {
    data: Object,
  },
};
</script>

<style lang="less" scoped>
.store-detail-header {
  width: 100%;
  height: auto;
  .store-name {
    width: 100%;
    height: 48/20rem;
    margin: 1/20rem 0;
    padding: 14/20rem 20/20rem;
    background-color: #fff;

    line-height: 20/20rem;
    font-weight: 500;
    font-size: 14/20rem;
    letter-spacing: 0;
    color: #333;
  }
  .store-info {
    gap: 18/20rem;

    width: 100%;
    height: 81/20rem;
    padding: 18/20rem 20/20rem;
    background-color: #fff;

    .store-desc {
      gap: 5/20rem;

      flex: 1;
      width: 0;
      height: 45/20rem;
      padding-bottom: 2/20rem;

      .store-manager {
        height: 21/20rem;
        line-height: 21/20rem;
        font-weight: 500;
        font-size: 15/20rem;
        letter-spacing: 0;
        color: #000;
      }

      .store-salers {
        height: 17/20rem;
        line-height: 17/20rem;
        font-weight: 500;
        font-size: 12/20rem;
        letter-spacing: 0;
        color: #b3b3b3;
      }
    }
  }
}
</style>
